import styled from 'styled-components';

export const Placeholder = styled.div<{ height?: number }>`
  height: ${props => (props.height ? `${props.height}px` : null)};
`;
